import style from './accordion-list.scss';
import timing from 'DesignSystem/motion/timing';
import easingJs from 'DesignSystem/motion/easing-js'
import $ from 'jquery';
import 'jquery.easing';

const script = () => {
  const cssClass: string = 'AccordionList';
  const cssClassExpanded: string = 'isExpanded';
  const target: string = `.${cssClass}-list`;
  const targets: any = document.querySelectorAll(target);

  for (const elt of targets) {

    // Test if element is init
    if (elt.dataset[`init${cssClass}`]) {
      return true; // already init go to next iteration
    }
    // Init element
    elt.dataset[`init${cssClass}`] = true;

    // Get items of accordion
    const eltItems = elt.querySelectorAll(`.${cssClass}-item`);
    if (eltItems.length > 1) {
      let isFirstItem = true;

      for (const item of eltItems) {
        const itemTitle = item.querySelector(`.${cssClass}-subTitle`);
        const itemSection = item.querySelector(`.${cssClass}-section`);

        if (itemTitle && itemSection) {

          // Collapse item by default
          $(itemSection).stop().slideUp();

          // Add expanded class on item
          if (isFirstItem) {
            item.classList.add(cssClassExpanded);
            isFirstItem = false;
            $(itemSection).stop().slideDown();
          }

          // Add trigger on title
          const itemTrigger = document.createElement('span');
          itemTrigger.classList.add(`${cssClass}-trigger`);
          itemTrigger.addEventListener('click', () => {
            $(itemSection).stop().slideToggle({
              duration: timing.params.std,
              easing: easingJs.params.standard,
            });
            $(item).toggleClass(cssClassExpanded);
          });
          itemTitle.appendChild(itemTrigger);
        }
      }
    }
  }
};

export {
  style,
  script,
};
